import { ActionTypes, IAction, IPageState } from './types';

export const InitialState: IPageState = {
  loading: false,
  pagedPoliticas: {
    count: 0,
    offset: 0,
    records: [],
    pageSize: 20,
  },
};

export const Reducer = (state: IPageState, action: IAction): IPageState => {
  switch (action.type) {
    case ActionTypes.UPDATE_LOADING_STATUS:
      return {
        ...state,
        loading: action.payload?.status ?? false,
      };
    case ActionTypes.UPDATE_PAGED_POLITICAS:
      return {
        ...state,
        loading: false,
        pagedPoliticas: action.payload?.pagedPoliticas ?? { ...InitialState.pagedPoliticas },
      }
    default:
      return { ...state };
  }
};
